import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';

interface Option {
  value: string | number;
  label: string;
  hide?: boolean;
}

interface FormSelectProps {
  name: string;
  label: string;
  options: Option[];
  control: any;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  size?: 'small' | 'medium';
  isShrink?: boolean;
}

const FormSelect = ({ 
  name, 
  label, 
  options, 
  control, 
  error,
  helperText,
  disabled = false,
  required = false,
  placeholder,
  size = 'small',
  isShrink = false
}: FormSelectProps) => (
  <Controller
    name={name}
    control={control}
    rules={{ required: required ? `${label} is required` : false }}
    render={({ field, fieldState }) => (
      <FormControl 
        fullWidth 
        size={size}
        error={!!fieldState.error || !!error}
        disabled={disabled}
      >
        <InputLabel required={required} shrink={isShrink}>
          {label}
        </InputLabel>
        <Select 
          {...field} 
          label={label}
          value={field.value || ''} 
          displayEmpty={!!placeholder}
        >
          {placeholder && (
            <MenuItem value="" disabled className='text-disabled'>
              <em>{placeholder}</em>
            </MenuItem>
          )}
          {options.map((option) => (
            !option.hide && (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            )
          ))}
        </Select>
        {(fieldState.error || error || helperText) && (
          <FormHelperText>
            {fieldState.error?.message || error || helperText}
          </FormHelperText>
        )}
      </FormControl>
    )}
  />
);

export default FormSelect;